/**
 * Pienentää kuvan selaimessa ennen lähetystä (pisin sivu 2000 px, JPEG 85 %).
 * Puhelimen 4–8 Mt kuva pienenee noin 0,5 Mt:hen, joten lataus on nopea myös mobiiliyhteydellä.
 * Selain kääntää kuvan EXIF-suunnan mukaan oikein päin. Jos selain ei osaa avata kuvaa
 * (esim. HEIC vanhassa selaimessa), lähetetään alkuperäinen ja palvelin tarkistaa tyypin.
 */
export async function resizeImage(file: File, maxSide = 2000, quality = 0.85): Promise<Blob> {
  if (!file.type.startsWith('image/')) return file;
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = reject;
      el.src = url;
    });
    const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
    if (scale === 1 && file.size < 1.5 * 1024 * 1024 && file.type !== 'image/png') return file;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', quality),
    );
    return blob ?? file;
  } catch {
    return file;
  } finally {
    URL.revokeObjectURL(url);
  }
}
